// @flow
import InformsPacks from './InformsPacks';

export default InformsPacks;
